export default __webpack_public_path__ + "static/media/blue-tick.9ea24058.svg";